'use client';

import { useSyncExternalStore } from 'react';
import { LAST_LOCATION_STORAGE } from './lastLocation';

/**
 * The last location the customer picked anywhere in the flow, read safely for rendering.
 *
 * `LAST_LOCATION_STORAGE` lives in localStorage, so reading it directly while rendering
 * makes the server emit one value and the client another — React then warns and discards
 * the mismatched input. `useSyncExternalStore` renders the server snapshot during
 * hydration and swaps in the real value straight after, which keeps the markup identical.
 * Both hooks return primitives, so the snapshot stays referentially stable across renders.
 */
const subscribe = () => () => undefined;
export function useLastLocationQuery() {
  return useSyncExternalStore(subscribe, _temp, _temp2);
}
function _temp2() {
  return null;
}
function _temp() {
  return LAST_LOCATION_STORAGE.getValue()?.query ?? null;
}
export function useLastLocationRadius() {
  return useSyncExternalStore(subscribe, _temp3, _temp4);
}
function _temp4() {
  return null;
}
function _temp3() {
  return LAST_LOCATION_STORAGE.getValue()?.radius ?? null;
}